import { MenuItem } from "@mui/material";
import { Form } from "formik";
import * as yup from "yup";
import { StyledProviderProvidedServiceForm } from "../../styled/providers";
import FormikForm from "../formik/formikForm";
import FormikSelect from "../formik/formikSelect";
import CircularLoading from "../loadingData/circularLoading";

const validationSchema = yup.object().shape({
  art: yup.string().required("La ART es obligatoria"),
});

const ArtProvidedServiceSearchForm = ({
  loading,
  arts,
  handleSubmitSearch,
  initialValues,
}) => {
  return (
    <div>
      <StyledProviderProvidedServiceForm.StyledPaper>
        {!loading ? (
          <FormikForm
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmitSearch}>
            {({ values }) => (
              <Form>
                <StyledProviderProvidedServiceForm.StyledInput>
                  <FormikSelect name="art" label="Art" variant="standard">
                    {arts.map((art) => (
                      <MenuItem value={art.id} key={art.id}>
                        {art.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledProviderProvidedServiceForm.StyledInput>
                <StyledProviderProvidedServiceForm.ButtonContainer>
                  <StyledProviderProvidedServiceForm.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={loading}>
                    Buscar
                  </StyledProviderProvidedServiceForm.StyledButton>
                </StyledProviderProvidedServiceForm.ButtonContainer>
              </Form>
            )}
          </FormikForm>
        ) : (
          <CircularLoading />
        )}
      </StyledProviderProvidedServiceForm.StyledPaper>
    </div>
  );
};

export default ArtProvidedServiceSearchForm;